export enum CancellationPolicyTag {
    FreeCancellation = 'FreeCancellation',
    NonRefundable = 'NonRefundable',
    PartiallyRefundable = 'PartiallyRefundable',
}
